import Group from '@/components/descriptors/group'

export default {
  name: 'rf-radio-group',
  extends: Group
}
